import script from "./ReunaMe.vue?vue&type=script&setup=true&lang=js"
export * from "./ReunaMe.vue?vue&type=script&setup=true&lang=js"

import "./ReunaMe.vue?vue&type=style&index=0&id=2e9659ba&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e9659ba"]])

export default __exports__